import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import {
  CustomDialogProps,
  SmartForm,
  SmartSubmit,
  SmartTextField,
} from "@nodeon/react-components";
import { useSnackbar } from "notistack";
import React from "react";
import { useTranslation } from "react-i18next";
import { ReturnNodeDto, useFileApi } from "~/api/GeneratedApi";

interface Props {
  parent: ReturnNodeDto;
  onSubmitted?: (node: ReturnNodeDto) => void;
}

interface FormProps {
  name: string;
}

const AddFolderPopupForm = ({
  parent,
  handleClose,
  onSubmitted,
}: CustomDialogProps & Props): JSX.Element => {
  const { t } = useTranslation("file-explorer");
  const { enqueueSnackbar } = useSnackbar();

  const onSuccess = (data: FormProps, res: ReturnNodeDto) => {
    enqueueSnackbar(t("folder-created", { folder: data.name }), {
      variant: "success",
    });
    handleClose?.();
    onSubmitted?.(res);
  };

  const fileApi = useFileApi();

  const onSubmit = (data: FormProps) => {
    return fileApi.addFolder({
      parentId: parent.id,
      name: data.name,
    });
  };
  return (
    <Dialog open onClose={handleClose} aria-labelledby="form-dialog-title">
      <SmartForm<FormProps, ReturnNodeDto>
        onSubmit={onSubmit}
        noGrid
        onSuccess={(data, res) => onSuccess(data, res)}
        formProps={{
          defaultValues: { name: "" },
        }}
      >
        <DialogTitle id="form-dialog-title">
          {t("add-folder-dialog-title", { folder: parent.name })}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <SmartTextField<FormProps>
                fullWidth
                name="name"
                label={t("new-folder-name")}
                required
                autoFocus
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t("general:cancel")}
          </Button>
          <SmartSubmit>{t("general:add")}</SmartSubmit>
        </DialogActions>
      </SmartForm>
    </Dialog>
  );
};

export default AddFolderPopupForm;
